export default __webpack_public_path__ + "assets/code.cfb57c80.svg";